import { Controller } from "@hotwired/stimulus";
import { newLookReviewOrderPath } from "src/routes";

export default class extends Controller {
  static targets = ["submitButton", "submitButtonIcon"];

  declare submitButtonTarget: HTMLElement;
  declare submitButtonIconTarget: HTMLElement;

  onSubmit() {
    this.submitButtonTarget.classList.add("is-loading");
    this.submitButtonIconTarget.classList.remove("is-completely-hidden");

    window.location.href = newLookReviewOrderPath();
  }
}
